<template>
  <div style="position: relative; z-index: 9;">
    <b-card class="api-keys-container">
      <template slot="header">
        <b-card-title>
          <strong>{{title}}</strong>
          <p-button type="success" round size="sm" style="float:right;" @click.native="onCreateKey">Create Key</p-button>
        </b-card-title>
        <p class="card-category my-4">{{subTitle}}</p>
      </template>
      <template slot="default">
        <template v-for="item in apiKeys">
          <b-container class="api-key-row">
            <b-row>
              <b-col class="d-flex justify-content-between align-items-center my-2">
                <strong>{{item.title}}</strong>
                <b-dropdown variant="link" size="sm" no-caret right>
                  <template slot="button-content"><i class="fa fa-ellipsis-v" /></template>
                  <b-dropdown-item @click="onEditKey(item)">Edit</b-dropdown-item>
                  <b-dropdown-item @click="onDeleteKey(item)">Delete</b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6" class="mb-2">
                <div class="api-key-copier">{{item.key}}<i class="fa fa-files-o" @click="onCopyKey(item, $event)" /></div>
              </b-col>
              <b-col>
                <div class="api-key-updated"><strong class="mr-2">Last Modified: </strong><span>{{parseDateTime(item.updated || item.created)}}</span></div>
                <div class="api-key-scopes"><strong class="mr-4">Scopes: </strong><span v-for="scope in item.scopes">{{scope}}</span></div>
              </b-col>
            </b-row>
          </b-container>
        </template>
        <b-loading :loading="loading" />
      </template>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

import ModalBus from '@/buses/modal'

export default {
  data() {
    return {
      title: "API Keys",
      subTitle: "You need an API Key to make requests against the QuickReceipts API. Read more about API access tokens in our documentation.",
      processing: false,
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'loading',
      'user',
      'apiKeys',
    ])
  },
  methods: {
    onCreateKey() {
      ModalBus.$emit('createApiKeyModal.open')
    },
    parseDateTime(d) {
      const dd = moment(d)
      return dd.format('MMMM D, YYYY') + ' at ' + dd.format('h:mm A')
    },
    onEditKey(item) {
      ModalBus.$emit('editApiKeyModal.open', item)
    },
    onDeleteKey(item) {
      ModalBus.$emit('deleteApiKeyModal.open', item)
    },
    onCopyKey(item, e) {
      var range = document.createRange()
      range.selectNode(e.target.parentElement)
      window.getSelection().removeAllRanges()
      window.getSelection().addRange(range)
      document.execCommand("copy")

      this.$bvToast.toast('This key has been copied to clipboard.', {
        title: `Key - ${item.title}`,
        variant: 'custom',
        autoHideDelay: 2000,
        solid: true
      })
    }
  },
  mounted() {
    // this.$store.dispatch('loadKeys')
  }
}
</script>
<style lang="scss">
.api-keys-container {
  .card-body {
    max-height: calc(100vh - 300px);
    overflow: auto;
  }
}
.api-key-row {
  border-top: solid 1px #ddd;
  .api-key-copier {
    word-break: break-all;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 3px;
    background-color: #F3F4F5;
    display: flex;
    align-items: center;
    i {
      margin-left: 1rem;
      padding: 5px;
      font-size: 10px;
      display: block;
      width: auto;
      border-radius: 2px;
      background-color: #4AC8E2;
      color: #fff;
      cursor: pointer;
    }
  }
  .api-key-updated {
    span {
      font-size: 13px;
      color: #333;
    }
  }
  .api-key-scopes {
    font-size: 14px;
    span {
      font-size: 12px;
      background: #ddd;
      padding: 2px 4px;
      margin: 0 4px 2px 0;
      border-radius: 2px;
    }
  }
}
</style>
